import React from "react"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { useShopId } from "../../hooks/shop"
import { useOrderFindList } from "../../hooks/order"
import OrderTable from "./OrderTable"
import { useLimit, useOffset } from "../../hooks/pagination"
import { useShopSalePointId } from "../../hooks/shopSalePoint"

export default function OrderList() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  const limit = useLimit()
  const offset = useOffset()

  let { isLoading, isError, orders, meta } = useOrderFindList(enterpriseId, {
    shopId,
    shopSalePointId,
    limit,
    offset,
  })

  if (isLoading) {
    return <p>Загрузка...</p>
  }

  if (isError) {
    return <p>Ошибка: {isError}</p>
  }

  return <OrderTable orders={orders} meta={meta} />
}
